import {
  createContext,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
} from 'react';

const CompleteContractAnimationContext = createContext(
  {} as {
    isAnimationStart: boolean;
    setIsAnimationStart: Dispatch<SetStateAction<boolean>>;
    reward: {
      cash: number;
      point: number;
      dice?: number;
      silverTicket?: number;
      bingoBalls?: number;
    };
    setReward: Dispatch<
      SetStateAction<{
        cash: number;
        point: number;
        dice?: number;
        silverTicket?: number;
        goldTicket?: number;
        diamondTicket?: number;
        bingoBalls?: number;
      }>
    >;
    animationStep: 1 | 2 | 3;
    setAnimationStep: Dispatch<SetStateAction<1 | 2 | 3>>;
    contractId: string | null;
    setContractId: Dispatch<SetStateAction<string | null>>;
    contractListWrapperRef: MutableRefObject<HTMLDivElement | null>;
    lastCompleteContractHasProductOfDayRef: MutableRefObject<boolean>;
  },
);

export { CompleteContractAnimationContext };
